export const applyCharge = (amount) => {
    const amountInNumber = Number(amount);
    let tax = 0;
    let processingFee = 0;

    if (amountInNumber <= 5000) {
        tax = 0.75;
        processingFee = 10;
    } else if (amountInNumber <= 50000) {
        tax = 1.88;
        processingFee = 25;
    } else {
        tax = 3.75;
        processingFee = 50;
    }

    const charge = tax + processingFee;
    const newAmount = charge + amountInNumber;

    return { newAmount, charge };
};
